import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionAf2EditarComponent {
  constructor($q, $catalogos, FanProyectoConfiguracionAf2Service) {
    this.$q = $q
    this.$catalogos = $catalogos
    this.FanProyectoConfiguracionAf2Service = FanProyectoConfiguracionAf2Service
    this.idProyecto = undefined
    this.onChange = undefined
    this.onClose = undefined
  }

  $onInit() {
    this.promise = this.$q.all([
        this.FanProyectoConfiguracionAf2Service.get(this.idProyecto)
          .then((response) => (this.data = response.data)),
        this.$catalogos.get('clientes')
          .then((data) => (this.clientes = data)),
        this.$catalogos.get('cuentasBancarias')
          .then((data) => (this.cuentasBancarias = data)),
      ])
      .then(() => (this.filtrarBancos()))
  }

  actualizar() {
    this.actualizando = true

    return this.FanProyectoConfiguracionAf2Service.put(this.idProyecto, this.data)
      .then((response) => {
        angular.extend(this.data, response.data)
        this.onChange({$event: {data: this.data}})
      })
      .finally(() => (this.actualizando = false))
  }

  cancelar() {
    this.onClose()
  }

  filtrarBancos() {
    this.cuentasBancariasMxn = this.cuentasBancarias.filter((item) => item.ID_Cliente === this.data.AF2_ID_Empresa && item.ID_Moneda === '1')
    this.cuentasBancariasUsd = this.cuentasBancarias.filter((item) => item.ID_Cliente === this.data.AF2_ID_Empresa && item.ID_Moneda === '2')
  }

  seleccionarEmpresa() {
    this.data.AF2_ID_Cuenta_MXN = ''
    this.data.AF2_ID_Cuenta_USD = ''

    this.filtrarBancos()
  }
}

module.component('fanProyectoConfigAf2Editar', {
  controller: FanProyectoConfiguracionAf2EditarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/af2/editar/component.js